const getPopoutUrlKey = name =>
  `popout-${name}-url`;

export default getPopoutUrlKey;